import { render } from "./ProductGallary.vue?vue&type=template&id=31ef600a&scoped=true"
import script from "./ProductGallary.vue?vue&type=script&lang=js"
export * from "./ProductGallary.vue?vue&type=script&lang=js"

import "./ProductGallary.vue?vue&type=style&index=0&id=31ef600a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.25_vue@3.5.25_typescript@5.4.2__webpack@5.103.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31ef600a"]])

export default __exports__